import React, { useEffect, useState } from 'react'

export default function ImagePreview(props) {
  const [file, setFile] = useState(props.stored)
  const [image, setImage] = useState(props.stored)

  async function handleChange(event) {
    const incoming = event.target.files[0]
    if (!incoming) {
      return
    }

    setFile(URL.createObjectURL(incoming))

    const reader = new FileReader()
    reader.addEventListener(
      'load',
      () => {
        setImage(reader.result)
      },
      false
    )

    reader.readAsDataURL(incoming)
  }

  async function remove(e) {
    e.preventDefault()

    const field = props.name
    const token = document.querySelector(
      'input[name="authenticity_token"]'
    ).value

    await fetch('/clinic/assets.json', {
      method: 'DELETE',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'X-CSRF-Token': token,
        Accept: 'application/json',
      },
      body: JSON.stringify({
        assets: {
          [field]: true,
        },
      }),
    })

    setFile(null)
    setImage(null)
  }

  return (
    <div>
      <input
        type="file"
        name={`prescription_template_placeholder[${props.name}]`}
        placeholder={props.placeholder}
        accept={props.accept}
        onChange={handleChange}
      />

      <input
        type="hidden"
        name={`prescription_template[${props.name}]`}
        value={image ?? ''}
      />

      <div className="editor">
        {file && <img className="preview" src={file} />}
      </div>

      {file && (
        <div className="toolbar">
          <button onClick={remove}>
            <i className="fal fa-trash"></i>
          </button>
        </div>
      )}
    </div>
  )
}
